import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@/app/config/query-client';

export function QueryProvider({ children }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
